import React from 'react';
import { Button, Tooltip } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useBeraReportV2 } from '@/context/BeraReportV2';
import { CheckCircleIcon, CloseCircleIcon } from '@/assets/icons/v2';

import { ConfirmButton, DiscardEditButton, HeaderRow, MarkStretchButton, TlidActions } from './styles';

export function Header(): JSX.Element {
	const {
		canAddStretch,
		hasUnsavedStretch,
		isEditMode,
		isSaving,
		isVideoUnavailable,
		outOfRangeStretchIds,
		rulerStretches,
		selectedTaskId,
		onAddStretch,
		onToggleEditMode,
		onCancelEditMode
	} = useBeraReportV2();

	const isEditingTlid = !!selectedTaskId;

	const hasOutOfRangeStretch = !!outOfRangeStretchIds.length;

	const canMarkStretch = canAddStretch && !hasUnsavedStretch && !isEditMode && !hasOutOfRangeStretch;

	const canEditStretches = !!rulerStretches.length && !hasUnsavedStretch && !isEditingTlid && !isVideoUnavailable;

	let editHint = '';

	if (isEditingTlid) {
		editHint = I18n.get('Confirm or discard the TLID first');
	}

	if (hasUnsavedStretch) {
		editHint = I18n.get('Confirm or discard the new stretch first');
	}

	return (
		<HeaderRow>
			<MarkStretchButton disabled={!canMarkStretch} onClick={onAddStretch}>
				{I18n.get('Mark new stretch')}
			</MarkStretchButton>
			{isEditMode && (
				<TlidActions>
					<DiscardEditButton
						icon={<CloseCircleIcon />}
						disabled={isSaving}
						aria-label={I18n.get('Discard')}
						onClick={onCancelEditMode}
					/>
					<ConfirmButton
						icon={<CheckCircleIcon />}
						loading={isSaving}
						aria-label={I18n.get('Finish editing')}
						onClick={onToggleEditMode}
					/>
				</TlidActions>
			)}
			{!isEditMode && (
				<Tooltip title={editHint}>
					<span>
						<Button type="link" disabled={!canEditStretches} onClick={onToggleEditMode}>
							{I18n.get('Edit all stretches')}
						</Button>
					</span>
				</Tooltip>
			)}
		</HeaderRow>
	);
}
